export default {"src":"/_next/static/media/Geriatric Nutrition.e5776028.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};